import { useEffect } from "react";
import { F, D } from "../../../styles/palette";
import { DC, Bdg } from "../../shared";
import useAdminStats from "../../../hooks/useAdminStats";

const ACCION_LABELS = {
  crear_paciente: "Nuevo paciente",
  actualizar_paciente: "Editar paciente",
  crear_evolucion: "Nueva evolución",
  subir_foto: "Subir foto",
  aceptar_consentimiento: "Consentimiento",
  aprobar_medico: "Aprobar médico",
  revocar_medico: "Revocar médico",
  login: "Inicio sesión",
  logout: "Cerrar sesión",
  ver_expediente: "Ver expediente",
  cambiar_rol: "Cambiar rol",
  reset_totp: "Reset TOTP",
  suspender_usuario: "Suspender usuario",
  reactivar_usuario: "Reactivar usuario",
};

const ACCION_COLORS = {
  crear_paciente: "#16a34a",
  crear_evolucion: "#0284c7",
  subir_foto: "#7c3aed",
  aprobar_medico: "#16a34a",
  revocar_medico: "#dc2626",
  login: "#64748b",
  default: "#94a3b8",
};

export default function AdminDashboard({ user }) {
  const { stats, loading, recentActivity, loadStats } = useAdminStats();

  useEffect(() => { loadStats(); }, [loadStats]);

  if (loading) {
    return <p style={{ color: D.txM, fontSize: 13, textAlign: "center", padding: 30 }}>Cargando estadísticas...</p>;
  }

  if (!stats) return null;

  const cards = [
    { label: "Pacientes activos", value: stats.totalPatients, color: "#2dd4bf", icon: "🫂" },
    { label: "Evoluciones", value: stats.totalRecords, color: "#38bdf8", icon: "📝" },
    { label: "Fotografías", value: stats.totalPhotos, color: "#a78bfa", icon: "📷" },
    { label: "Consentimientos", value: stats.totalConsents, color: "#fb923c", icon: "✅" },
    { label: "Médicos aprobados", value: stats.doctorsApproved, color: "#16a34a", icon: "👨‍⚕️" },
    { label: "Médicos pendientes", value: stats.doctorsPending, color: "#ca8a04", icon: "⏳" },
  ];

  return (
    <div>
      {/* Stats grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 10, marginBottom: 20 }}>
        {cards.map((c, i) => (
          <div key={i} style={{ background: D.card, border: `1px solid ${D.bdr}`, borderRadius: 12, padding: "16px 14px", backdropFilter: "blur(12px)", textAlign: "center" }}>
            <div style={{ fontSize: 24, marginBottom: 4 }}>{c.icon}</div>
            <div style={{ fontSize: 28, fontWeight: 800, color: c.color, fontFamily: F.m }}>{c.value}</div>
            <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>{c.label}</div>
          </div>
        ))}
      </div>

      {/* Activity summary */}
      <DC title={`Actividad últimos 7 días: ${stats.activityLast7Days} eventos`} accent="#2dd4bf">
        <div style={{ fontSize: 12, color: "#64748b", marginBottom: 8 }}>Últimos registros del audit log</div>
      </DC>

      {/* Recent activity */}
      <DC title="Actividad reciente" accent="#38bdf8">
        {recentActivity.length === 0 ? (
          <p style={{ color: D.txM, fontSize: 13, textAlign: "center" }}>Sin actividad reciente</p>
        ) : (
          recentActivity.slice(0, 15).map((l, i) => {
            const fecha = l.timestamp?.toDate ? l.timestamp.toDate() : null;
            const color = ACCION_COLORS[l.accion] || ACCION_COLORS.default;
            return (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: "1px solid rgba(100,116,139,0.06)" }}>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <Bdg t={ACCION_LABELS[l.accion] || l.accion} c={color} />
                  <span style={{ color: "#94a3b8", fontSize: 11 }}>{l.userEmail || l.userId}</span>
                </div>
                <span style={{ color: "#475569", fontSize: 10, fontFamily: F.m }}>
                  {fecha ? fecha.toLocaleDateString("es-CO", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : ""}
                </span>
              </div>
            );
          })
        )}
      </DC>
    </div>
  );
}
